var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: { click: _vm.btnClose }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis maintit" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.DASHBOARD.KPI.CONFIG")))]),
            _vm._v(" "),
            _c("em", { staticClass: "ico_info" }, [
              _c("i", { staticClass: "tooltip fl_btm" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.$t("MESSAGE.DASHBOARD.KPI.TOOLTIP")) +
                    "\n                        "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "box_wrap" }, [
              _c("div", { staticClass: "item_four" }, [
                _c("div", { staticClass: "step" }, [
                  _vm._v(_vm._s(_vm.$t("TITLE.DASHBOARD.KPI.STEP1")))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tree_box scroll",
                    attrs: { "data-type": "list" }
                  },
                  [
                    _c(
                      "ul",
                      _vm._l(_vm.KPIList, function(KPI) {
                        return _c("li", {
                          class: _vm.selKPI === KPI.val ? "active" : "",
                          attrs: { "data-val": KPI.val },
                          domProps: { innerHTML: _vm._s(KPI.name) },
                          on: {
                            click: function($event) {
                              return _vm.clickKPI(KPI.val)
                            }
                          }
                        })
                      }),
                      0
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "item_four",
                  class: !_vm.showCategory2 ? "disabled" : ""
                },
                [
                  _c("div", { staticClass: "step" }, [
                    _vm._v(_vm._s(_vm.$t("TITLE.DASHBOARD.KPI.STEP2")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tree_box scroll" }, [
                    _c(
                      "dl",
                      {
                        staticClass:
                          "tree_wrap noLine no-margin-top no-border-top"
                      },
                      [
                        _c("dd", [
                          _c("article", { staticClass: "tree_group" }, [
                            _c(
                              "ul",
                              { staticClass: "tree_list no-margin-top" },
                              [
                                _c("li", { staticClass: "active" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "ico_tree",
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.treeClick($event)
                                        }
                                      }
                                    },
                                    [_c("span", { staticClass: "sr_only" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticClass: "checkbox-wrap" },
                                    [
                                      _c("input", {
                                        attrs: {
                                          name: "checkAll",
                                          type: "checkbox",
                                          disabled: !_vm.showCategory2
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.treeChange($event, "all")
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("i", { staticClass: "check-icon" }),
                                      _vm._v(" "),
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(_vm.$t("FIELD.GLOBAL.ALL"))
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "tree_sub_list" },
                                    _vm._l(_vm.subsidiaryList, function(item) {
                                      return _c(
                                        "li",
                                        { key: _vm.pageName + item.code },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "ico_tree",
                                              attrs: { href: "javascript:" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.treeClick(
                                                    $event,
                                                    item.subCodeList
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "sr_only"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { staticClass: "checkbox-wrap" },
                                            [
                                              _c("input", {
                                                staticClass: "region",
                                                attrs: {
                                                  type: "checkbox",
                                                  name: item.code + "_all",
                                                  "data-name": item.codeName,
                                                  disabled: !_vm.showCategory2
                                                },
                                                domProps: { value: item.code },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.treeChange(
                                                      $event,
                                                      item.code
                                                    )
                                                  }
                                                }
                                              }),
                                              _c("i", {
                                                staticClass: "check-icon"
                                              }),
                                              _vm._v(" "),
                                              _c("em", [
                                                _vm._v(_vm._s(item.codeName))
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            {
                                              key:
                                                _vm.pageName +
                                                item.code +
                                                _vm.inquiryCount,
                                              staticClass: "tree_sub_list"
                                            },
                                            _vm._l(item.subCodeList, function(
                                              subCode
                                            ) {
                                              return _c(
                                                "li",
                                                {
                                                  key:
                                                    _vm.pageName +
                                                    item.code +
                                                    subCode.code
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-wrap"
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "subsidiary",
                                                        attrs: {
                                                          type: "checkbox",
                                                          name: item.code,
                                                          "data-name":
                                                            subCode.codeName,
                                                          disabled: !_vm.showCategory2
                                                        },
                                                        domProps: {
                                                          value: subCode.code
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.treeChange(
                                                              $event,
                                                              item.code,
                                                              subCode.code
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _c("i", {
                                                        staticClass:
                                                          "check-icon"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("em", [
                                                        _vm._v(
                                                          _vm._s(
                                                            subCode.codeName
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "item_four",
                  class: !_vm.showCategory3 ? "disabled" : ""
                },
                [
                  _c("div", { staticClass: "step" }, [
                    _vm._v(_vm._s(_vm.$t("TITLE.DASHBOARD.KPI.STEP3")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tree_box scroll",
                      attrs: { "data-type": "list" }
                    },
                    [
                      _c(
                        "ul",
                        _vm._l(_vm.menuGroupList, function(menuGrpDtl) {
                          return _c(
                            "li",
                            {
                              class: _vm.selMenuGrpDtlList.includes(
                                menuGrpDtl.MENU_GROUP_DETAIL_CD
                              )
                                ? "active"
                                : "",
                              attrs: {
                                value: menuGrpDtl.MENU_GROUP_DETAIL_CD,
                                "data-val": menuGrpDtl.MENU_GROUP_DETAIL_CD
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selMenuGroupDetail($event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(menuGrpDtl.MENU_GROUP_DETAIL_NM) +
                                  "\n                                    "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "item_four",
                  class: !_vm.showCategory4 ? "disabled" : ""
                },
                [
                  _c("div", { staticClass: "step" }, [
                    _vm._v(_vm._s(_vm.$t("TITLE.DASHBOARD.KPI.STEP4")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tree_box scroll" }, [
                    _c(
                      "dl",
                      {
                        staticClass:
                          "tree_wrap noLine no-margin-top no-border-top"
                      },
                      [
                        _c("dd", [
                          _c("article", { staticClass: "tree_group" }, [
                            _c(
                              "ul",
                              { staticClass: "tree_list no-margin-top" },
                              [
                                _c("li", { staticClass: "active" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "ico_tree",
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.catTreeClick($event)
                                        }
                                      }
                                    },
                                    [_c("span", { staticClass: "sr_only" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticClass: "checkbox-wrap" },
                                    [
                                      _c("input", {
                                        attrs: {
                                          name: "catCheckAll",
                                          type: "checkbox",
                                          disabled: !_vm.showCategory4
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.catTreeChange(
                                              $event,
                                              "all"
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("i", { staticClass: "check-icon" }),
                                      _vm._v(" "),
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "FIELD.DASHBOARD.ALL.CATEGORY"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "tree_sub_list" },
                                    _vm._l(_vm.categoryCodeList, function(
                                      item
                                    ) {
                                      return _c(
                                        "li",
                                        { key: _vm.pageName + item.code },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "ico_tree",
                                              attrs: { href: "javascript:" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.catTreeClick(
                                                    $event,
                                                    item.subCodeList
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "sr_only"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { staticClass: "checkbox-wrap" },
                                            [
                                              _c("input", {
                                                staticClass: "category1",
                                                attrs: {
                                                  type: "checkbox",
                                                  name: item.code + "_all",
                                                  "data-name": item.codeName,
                                                  disabled: !_vm.showCategory4
                                                },
                                                domProps: { value: item.code },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.catTreeChange(
                                                      $event,
                                                      item.code
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "check-icon"
                                              }),
                                              _vm._v(" "),
                                              _c("em", [
                                                _vm._v(_vm._s(item.codeName))
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            {
                                              key:
                                                _vm.pageName +
                                                item.code +
                                                _vm.inquiryCount,
                                              staticClass: "tree_sub_list"
                                            },
                                            _vm._l(item.subCodeList, function(
                                              subCode
                                            ) {
                                              return _c(
                                                "li",
                                                {
                                                  key:
                                                    _vm.pageName +
                                                    item.code +
                                                    subCode.code
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-wrap"
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "category2",
                                                        attrs: {
                                                          type: "checkbox",
                                                          name: item.code,
                                                          "data-name":
                                                            subCode.codeName,
                                                          disabled: !_vm.showCategory4
                                                        },
                                                        domProps: {
                                                          value: subCode.code
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.catTreeChange(
                                                              $event,
                                                              item.code,
                                                              subCode.code
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _c("i", {
                                                        staticClass:
                                                          "check-icon"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("em", [
                                                        _vm._v(
                                                          _vm._s(
                                                            subCode.codeName
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dashboard_btn" }, [
              _c(
                "a",
                {
                  staticClass: "btn-arrow",
                  attrs: { href: "javascript:" },
                  on: { click: _vm.btnAddKPI }
                },
                [
                  _c("span", { staticClass: "sr_only" }, [
                    _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.ADD")))
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w100p" }, [
              _c("div", { staticClass: "step" }, [
                _vm._v(_vm._s(_vm.$t("FIELD.DASHBOARD.SELECTED.CONTENT")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tree_box padding5_0 ",
                  attrs: { "data-type": "list" }
                },
                [
                  _vm.selectContentList.length === 0
                    ? _c("ul", { staticClass: "dashboard_list" }, [
                        _c("em", [_vm._v(" ")]),
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")) +
                            "\n                            "
                        )
                      ])
                    : _c(
                        "ul",
                        { staticClass: "dashboard_list" },
                        _vm._l(_vm.selectContentList, function(selCont, idx) {
                          return _c(
                            "li",
                            [
                              _c("em", [_vm._v(_vm._s(idx + 1) + ". ")]),
                              _vm._v(" "),
                              ["ICO", "MRCO"].includes(selCont.kpiCd)
                                ? [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(selCont.kpiNm) +
                                        " > " +
                                        _vm._s(selCont.subNm) +
                                        " (" +
                                        _vm._s(selCont.menuGrpNm) +
                                        ")\n                                    "
                                    )
                                  ]
                                : ["QA"].includes(selCont.kpiCd)
                                ? [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(selCont.kpiNm) +
                                        " > " +
                                        _vm._s(selCont.subNm) +
                                        " > " +
                                        _vm._s(selCont.catNm) +
                                        "\n                                    "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(selCont.kpiNm) +
                                        " > " +
                                        _vm._s(selCont.subNm) +
                                        " > " +
                                        _vm._s(selCont.menuGrpNm) +
                                        " > " +
                                        _vm._s(selCont.catNm) +
                                        "\n                                    "
                                    )
                                  ],
                              _vm._v(" "),
                              _c("div", { staticClass: "btn-ctrl_wrap" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "button-ctrl_first",
                                    on: {
                                      click: function($event) {
                                        return _vm.btnArrowTop(idx)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.TOP")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "button-ctrl_prev",
                                    on: {
                                      click: function($event) {
                                        return _vm.btnArrowUp(idx)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.UP")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "button-ctrl_next",
                                    on: {
                                      click: function($event) {
                                        return _vm.btnArrowDown(idx)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DOWN")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "button-ctrl_last",
                                    on: {
                                      click: function($event) {
                                        return _vm.btnArrowBottom(idx)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("BUTTON.GLOBAL.BOTTOM"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "button-ctrl_del",
                                    on: {
                                      click: function($event) {
                                        return _vm.btnArrowDelete(idx)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("BUTTON.GLOBAL.DELETE"))
                                    )
                                  ]
                                )
                              ])
                            ],
                            2
                          )
                        }),
                        0
                      )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnClose }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnSave }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")))]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cbd5865", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cbd5865","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/dashboard/popup/DashboardConfigPopup.vue
// module id = TEYG
// module chunks = 0